import { Container, Typography } from "@mui/material";
import { CriticalError } from "../CriticalError";
import { Group } from "../../components/";
import { InputButton } from "../../components/";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Page } from "../Page";
import { apiClient } from "../../api/";
import { showComplexSnackbarDispatcher } from "../../components/";
import { showSnackbar } from "../../components/";
import { styles } from "../../theme/";
import { useMemo, useState } from "react";

/**
 * NeedEmailVerification page
 */
export const NeedsEmailVerification = () => {
    // Hooks
    const location = useLocation();
    const navigate = useNavigate();

    // useStates
    const [, setError] = useState<boolean>(false);
    const [criticalError, setCriticalError] = useState<boolean>(false);

    // useMemos
    const token = useMemo(() => localStorage.getItem("token"), []);

    const pathname = location.pathname;

    // Handlers
    const handleResendEmail = async (token: string) => {
        try {
            const [response, statusOk] = await apiClient.sendEmailVerificationEmail(token);

            if (statusOk) {
                showSnackbar({ message: `Verification email sent.`, variant: "success" });
                showSnackbar({ message: `Verify your email.`, variant: "success" });
            } else {
                setError(true);
                showComplexSnackbarDispatcher(response as { [key: string]: string[]; });
            }

        } catch (error) {
            setCriticalError(true);
            showSnackbar({ message: String(error), variant: "error" });

        }
    };

    // Early return
    if (criticalError) return <CriticalError />;
    if (!token) return <Navigate to={`/signIn?to=${pathname}`} />;

    return (
        <Page menu needsAuthentication style={{ justifyContent: "flex-start" }} innerStyle={{ justifyContent: "center" }}>
            <Container style={styles.inPlaceModal} >
                <Typography style={{ fontFamily: "ArchivoBlack", fontSize: 36, textAlign: "center" }} >Please, verify your email</Typography>
                <Group direction="row">
                    <InputButton type="primary" onClick={() => navigate("/newEmail")} tooltip="Change email">Change email</InputButton>
                    <InputButton type="secondary" onClick={() => handleResendEmail(token)} tooltip="Resend verification email">Resend email</InputButton>
                </Group>
            </Container>
        </Page>
    );
};